module.exports = __webpack_public_path__ + "img/upgradeThin.3151ecb4.svg";